import { useAppConfig } from '../context/AppConfigContext';

export default function MaintenanceScreen() {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="text-6xl mb-6">🔧</div>
        <h1 className="text-3xl font-bold text-white mb-3">We'll be back soon</h1>
        <p className="text-slate-400 text-lg mb-2">
          LitX is undergoing scheduled maintenance.
        </p>
        <p className="text-slate-500 text-sm">
          We're working hard to improve your experience. Check back shortly.
        </p>
        <div className="mt-8 text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          LitX
        </div>
      </div>
    </div>
  );
}